import PropTypes from "prop-types";

import Wysiwyg from "../../components/shared/Wysiwyg";

export default function PricingReportPrintHtmlText({ html, className, component: Component = "div" }) {
  if (!html) return null;

  const rootClassName = ["pricing-report-print-html", className].filter(Boolean).join(" ");

  return (
    <Component className={rootClassName}>
      <Wysiwyg component="div">{html}</Wysiwyg>
    </Component>
  );
}

PricingReportPrintHtmlText.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.elementType,
};
